import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, handleDateChange, initializeFilterData } from "../CommonComponents/CustomHooks";
import { CommonApiData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const DealerReport = () => {
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch();
    let [result, setResult] = useState([]);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [loading, setLoading] = useState(false);
    const inputrefs = useRef([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const commonData = CommonApiData();

    let pqrDate = new Date()
    let dateArr = pqrDate?.toString()?.split(' ')
    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`

    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
    };
    const [formData, setFormData] = useState({
        ...Data,
        "fromDate": dateArr,
        "toDate": dateArr,
        "dealer": "",
    })

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleClear = () => {
        setFormData({
            ...formData,
            "fromDate": dateArr,
            "toDate": dateArr,
            "dealer": ""
        })
        filterData.SearchText = ''
        filterData.AdvanceFilter = []
        setSortConfig({ SortColumn: null, SortOrder: null })
        inputrefs.current['txtFromDate'].focus()
    }

    let PageName = 'DealerReport'
    const handleChange1 = (event, value) => {
        GetDealerReport(value);
    };

    const GetDealerReport = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...filterData,
            ...Data,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('', GetData)
        setLoading(false)
        if (data.Status === 'UNAUTHORIZED' || data.Status === 'ERROR' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message);
        }
        setResult(data)
    }
    let ExportRequest = {
        ...Data,
        ...formData,
        ...filterData,
        ...sortConfig,
        Type: 'E',
        PageIndex: '1'
    }
    useEffect(() => {
        GetDealerReport();
        inputrefs.current['txtFromDate'].focus()
        document.title = 'Dealer Report'
    }, [sortConfig]);

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{'Dealer Report'}</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <DateBox
                            id='txtFromDate'
                            inputrefs={inputrefs}
                            label='From Date'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtLogDateTo'].focus() };
                            }}

                        />
                        <DateBox
                            id='txtLogDateTo'
                            inputrefs={inputrefs}
                            label='To Date'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtFormName'].focus() };
                            }}
                        />
                        <AutoCompleteBoxNew
                            id="txtDealer"
                            placeholder="Dealer"
                            label={'Dealer'}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtbtn'].focus()
                                }
                            }}
                            contextKey={formData.dealer}
                            autocompleteType='GetDealerMaster'
                            value={formData.dealer || ''}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || ''
                                if (event.type !== 'keydown') {
                                    setFormData({ ...formData, dealer: newInputValue })
                                }
                            }}
                            maxLength='50'
                        />
                    </div>
                    <div className='d-block mt-3 d-md-flex' >
                        <button
                            ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                            onClick={GetDealerReport}
                            className="btn btn-rounded btn-primary">
                            <span className=" text-white me-2">
                                <i className="fa fa-search"></i>
                            </span>Search</button>
                        <button
                            className="btn btn-rounded btn-warning"
                            onClick={async () => {
                                try {
                                    dispatch(setSubLoading(true))
                                    await handleDownloadExcel('', ExportRequest, 'Dealer Report');
                                    dispatch(setSubLoading(false))

                                } finally {
                                    dispatch(setSubLoading(false))
                                }
                            }}
                        >
                            <span className="text-warning me-2">
                                <i className="fa fa-download text-white color-success"></i>
                            </span>
                            Export
                        </button>
                        <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                        </span>Reset</button>
                    </div>
                </div>
            </div>
            <Table
                PageName={PageName}
                loading={loading}
                handleFilter={() => {
                    GetDealerReport()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                setFilterData={setFilterData}
                tableData={result}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                Filter={false}
                onlyFilterPage={true}
            />
        </>
    )
}
export default DealerReport;